import {MatSnackBar} from "@angular/material/snack-bar";

import {Injectable} from "@angular/core";
@Injectable({
    providedIn: "root"
})
export class AlertsService {
    constructor(public snackBar: MatSnackBar) {
    }
    getAlert(message: string, action: string) {
        this.snackBar.open(message, action, {
            horizontalPosition: "center",
            verticalPosition: "top",
            duration: 5000
        })
    }

    getError(message: string, action: string) {
        this.snackBar.open(message, action, {
            horizontalPosition: "center",
            verticalPosition: "top",
            duration: 5000,
            panelClass: 'alert-danger'
        })
    }
}
